/* eslint-disable complexity */
import moment from "moment";

const DAY = 1,
	EMPTY = 0,
	DAYS_IN_WEEK = 7,
	ONE_WEEK = 1,
	ONE_MONTH = 1,
	ONE_YEAR = 1;

export function checkIfRangeDisabled(type) {
	const currentDay = moment(this.activeDate).format(),
		currentWeekStart = moment(this.activeDate).startOf("week").add(DAY, "day").format(),
		currentWeekEnd = moment(this.activeDate).endOf("week").add(DAY, "day").format(),
		currentMonthStart = moment(this.activeDate).startOf("month").format(),
		currentMonthEnd = moment(this.activeDate).endOf("month").format();

	this.dateOfValidity = this.activeOutlet.outlet_data_validity;

	switch (this.activePeriod) {
		case "day":
			if (type === "prev") {
				const diff = moment(currentDay).diff(this.minDate, "days");

				if (diff === EMPTY) this.prevDisabled = true;
				else this.prevDisabled = false;

				return this.prevDisabled;
			} else if (type === "next") {
				const diff = moment(currentDay).diff(this.dateOfValidity, "days");

				if (diff >= EMPTY) this.nextDisabled = true;
				else this.nextDisabled = false;

				return this.nextDisabled;
			}

			break;

		case "week":
			if (type === "prev") {
				const diff = moment(currentWeekStart).diff(this.minDate, "days");

				if (diff === EMPTY) this.prevDisabled = true;
				else this.prevDisabled = false;

				return this.prevDisabled;
			} else if (type === "next") {
				const daysThatHasDataCount = moment(this.dateOfValidity).diff(startWeekOfValidity, "days");
				let startWeekOfValidity = moment(this.dateOfValidity).subtract(DAY, "days").startOf("week").add(DAY, "days");

				// if there are not enough days in startWeekOfValidity, select the week before
				if (daysThatHasDataCount < DAYS_IN_WEEK) startWeekOfValidity = startWeekOfValidity.subtract(ONE_WEEK, "week");

				// eslint-disable-next-line one-var
				const diff = moment(currentWeekEnd).diff(startWeekOfValidity, "days");
				if (diff > EMPTY) this.nextDisabled = true;
				else this.nextDisabled = false;

				return this.nextDisabled;
			}

			break;

		case "month":
			if (type === "prev") {
				const diff = moment(currentMonthStart).diff(moment(this.minDate).startOf("month"), "days");

				if (diff === EMPTY) this.prevDisabled = true;
				else this.prevDisabled = false;

				return this.prevDisabled;
			} else if (type === "next") {
				const diff = moment(currentMonthEnd).diff(moment(this.dateOfValidity).endOf("month"), "days");

				if (diff === EMPTY) this.nextDisabled = true;
				else this.nextDisabled = false;

				return this.nextDisabled;
			}

			break;

		case "year":
			if (type === "prev") {
				const activeYear = moment(this.activeDate).year();

				if (activeYear <= moment(this.minDate).year()) this.prevDisabled = true;
				else this.prevDisabled = false;

				return this.prevDisabled;
			} else if (type === "next") {
				const activeYear = moment(this.activeDate).year();

				if (activeYear >= moment(this.dateOfValidity).year()) this.nextDisabled = true;
				else this.nextDisabled = false;

				return this.nextDisabled;
			}

			break;
	}
}

export function nextDataRange(local) {
	if (this.checkIfRangeDisabled("next")) return;

	switch (this.mode) {
		case "date":
			this.date = moment(this.date).add(DAY, "days").toDate();
			this.setActiveDate(this.date);
			this.$emit("input", this.date.toString());
			break;

		case "range":
			this.date = {
				start: moment(this.date.start).add(ONE_WEEK, "week").toDate(),
				end: moment(this.date.end).add(ONE_WEEK, "week").toDate(),
			};

			this.setActiveDate(this.date.start);
			this.$emit("input", this.date.start.toString());
			break;

		case "month":
			this.date = moment(this.date).add(ONE_MONTH, "month");

			this.setActiveDate(this.date);
			this.$emit("input", this.date.toString());
			break;

		case "year":
			if (String(moment(this.date).year()) === this.availableYears[0]) return;

			this.date = moment(this.date).add(ONE_YEAR, "year");

			this.setActiveDate(this.date);
			this.$emit("input", this.date.toString());

			// refresh comparison period
			this.selectPeriod(this.activePeriod);

			break;
	}

	if (!local) this.reloadComponentData();
}

export function prevDataRange(local) {
	if (this.checkIfRangeDisabled("prev")) return;

	this.showCalendar = false;

	switch (this.mode) {
		case "date":
			this.date = moment(this.date).subtract(DAY, "days").toDate();

			this.setActiveDate(this.date);
			this.$emit("input", this.date.toString());
			break;

		case "range":
			this.date = {
				start: moment(this.date.start).subtract(ONE_WEEK, "week").toDate(),
				end: moment(this.date.end).subtract(ONE_WEEK, "week").toDate(),
			};

			this.setActiveDate(this.date.start);
			this.$emit("input", this.date.start.toString());
			break;

		case "month":
			this.date = moment(this.date).subtract(ONE_MONTH, "month");

			this.setActiveDate(this.date);
			this.$emit("input", this.date.toString());
			break;

		case "year": {
			const DECREMENT = 1,
				lastYear = this.availableYears[this.availableYears.length - DECREMENT];

			if (String(moment(this.date).year()) === lastYear) return;

			this.date = moment(this.date).subtract(ONE_YEAR, "year");

			this.setActiveDate(this.date);
			this.$emit("input", this.date.toString());

			// refresh comparison period
			this.selectPeriod(this.activePeriod);

			break;
		}
	}

	if (!local) this.reloadComponentData();
}
